import { render } from "./HeroiconsOutlineFire.vue?vue&type=template&id=f4188348"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFire.vue"]])

export default __exports__